import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect, useSelector } from "react-redux";
import { css } from "styled-components";
import Drawer from "@insite/mobius/Drawer";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import toggleTrackOrderDrawer from "@NA/Handlers/ADITrackOrderDrawerHandler";
import ADIColors from "@NA/Utils/ADIColors";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import Button, { ButtonPresentationProps, ButtonProps, ButtonWrapper } from "@insite/mobius/Button";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { getProp } from "@insite/mobius/utilities";
import Search from "@insite/mobius/Icons/Search";
import { AccordionSectionHeader, AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { CustomSettingCollectionModel } from "@NA/Store/CustomTypeModel/CustomSettingCollectionModel";
import { useOutsideAlerter } from "@NA/Hooks/useOutsideAlerter";
import { spaceValidation } from "@NA/Utils/Utility";
import loadOrdersList from "@NA/Handlers/ADILoadOrdersListHandler";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import DropDown from "@NA/Icons/DropDown";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";

const mapStateToProps = (state: CustomApplicationState) => ({
    ordersDataView: state.ADIGlobalData.ordersListStore.ordersList,
    session: state.context.session,
    settingsCollection: getSettingsCollection(state) as unknown as CustomSettingCollectionModel,
    getOrdersParameter: state.ADIGlobalData.ordersListStore.parameter,
});

const mapDispatchToProps = {
    toggleTrackOrderDrawer,
    loadOrdersList,
    toggleLoginDrawer,
};

export interface TrackOrderStyles {
    trackOrderLink?: LinkPresentationProps;
    modalTitle?: TypographyPresentationProps;
    modalContent?: TypographyPresentationProps;
    formRowLabel?: TypographyPresentationProps;
    trackOrderButtonContainer?: GridContainerProps;
    trackOrderButtonGridItem?: GridItemProps;
    primaryButton?: ButtonPresentationProps;
    secondaryBtutton?: ButtonPresentationProps;
    trackOrderContainer?: GridContainerProps;
    trackOrderTextBox?: InjectableCss;
    errorMessage?: TypographyProps;
    icon?: TypographyProps;
    trackOrderGrid?: GridItemProps;
    gridItem?: GridItemProps;
    dropdownContainer?: InjectableCss;
    dropdownValue?: InjectableCss;
    dropdownList?: InjectableCss;
    dropdownValues?: InjectableCss;
    dropdownLabel?: InjectableCss;
    input?: TextFieldPresentationProps;
    Accordion?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const trackOrderStyles: TrackOrderStyles = {
    trackOrderLink: {
        typographyProps: {
            variant: "headerSecondary",
        },
        icon: {
            iconProps: {
                size: 30,
                css: css`
                    height: 28px;
                    width: auto;
                    position: relative;
                    top: 0px;
                    transform: translateY(-1px) scale(0.9);
                    svg {
                        stroke: ${ADIColors.darkBlue1};
                    }
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    top: 1px;
                                `,
                                null,
                                css`
                                    top: 1px;
                                `,
                            ],
                            "max",
                        );
                    }}
                `,
            },
        },
        color: "secondary",
        css: css`
            padding: 0px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0px;
            flex-direction: column;
            cursor: pointer!important;
            pointer-events: initial!important;
            margin-top: 12px;
            &:hover {
                text-decoration: underline;
            }
            ${IconWrapper} {
                margin-right: 0px;
            }
            ${TypographyStyle} {
                color: #2D2926;
                font-size: 14px;
                font-weight: 600;
                line-height: normal;
                //text-transform: lowercase;
                position: relative;
                top: 0px;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },

    modalTitle: {
        css: css`
            font-size: 24px;
            font-weight: bold;
            line-height: normal;
            text-align: left;
            color: ${ADIColors.darkBlue1};
            padding: 0px 15px;
            margin-bottom: 25px;
        `,
    },
    modalContent: {
        css: css`
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            color: ${ADIColors.black};
            padding: 0px 15px;
            margin-bottom: 25px;
        `,
    },

    formRowLabel: {
        css: css`
            font-size: 14px;
            font-weight: 700;
            color: #2D2926;
            padding: 0;
            display: inline-block;
            line-height: normal;
            margin-bottom: 0px;
            min-height: 22px;
        `,
    },
    trackOrderButtonContainer: {
        offsetCss: css`
            width: 100% !important;
            margin: auto;
            background-color: ${ADIColors.gray6};
            padding: 25px 15px 30px 15px;
            position: absolute;
            bottom: 0px;
            top: auto;
            border-top: 1px solid ${ADIColors.gray3};
            z-index: 99;
        `,
    },
    trackOrderButtonGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            align-items: center;
            flex-direction: row;
            justify-content: flex-end;
            padding: 0px;
            gap: 0px;
        `,
    },

    primaryButton: {
        css: css`
            width: 50%;
            height: 35px;
            min-height: 35px;
            border-radius: 4px;
            padding: 0 10px;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            margin: 0px;
            margin-left: 10px;
            line-height: normal;
            > ${TypographyStyle} {
                font-size: 14px;
                font-weight: bold;
            }
            &:disabled{
                background: #006AE3;
                border-color: #006AE3;
                color: #FFFFFF;
                opacity: .5;
            }
        `,
    },
    secondaryBtutton: {
        css: css`
            width: 50%;
            height: 35px;
            min-height: 35px;
            font-size: 14px;
            font-weight: bold;
            padding: 0 10px;
            text-align: center;
            border-radius: 4px;
            margin: 0;
            margin-right: 10px;
            line-height: normal;
            background-color: ${ADIColors.white};
            border: 1px solid ${ADIColors.blue1};
            > ${TypographyStyle} {
                font-size: 14px;
                font-weight: bold;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
        `,
    },

    trackOrderContainer: {
        css: css`
            ${GridItemStyle} {
                padding: 0px 15px 0px 15px;
                margin-bottom: 20px;
            }
            ${GridOffset} {
                margin: 0px;
                width: 100%;
            }
        `,
    },

    icon: {
        css: css`
            transform: translateY(-1px) scale(0.9);
            svg {
                stroke: ${ADIColors.darkBlue1};
            }
        `,
    },
    trackOrderGrid: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            flex-direction: column;
        `,
    },
    gridItem: {
        css: css`
            flex-direction: column;
            flex-basis: 100%;
            max-width: 100%;
            &[data-test-selector="ordersStatusGridItem"] {
                flex-basis: 100%;
                max-width: 100%;
            }
        `,
    },
    dropdownLabel: {
        css: css`
            font-weight: 700;
            text-transform: capitalize;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            margin-bottom: 6px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin-bottom: 6px;
                        line-height: 22px;
                        font-weight: 800;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    dropdownContainer: {
        css: css`
            position: relative;
            width: 100%;
            .orderactive {
                z-index: 8;
            }
        `,
    },
    dropdownValue: {
        css: css`
            width: 100%;
            border: 1px solid;
            border-radius: 6px;
            padding: 9px 9px 9px 15px;
            height: 40px;
            background: ${ADIColors.white};
            border: 1px solid ${ADIColors.gray3};
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            cursor: pointer;
            position: relative;
            z-index: 10;
            display: flex;
            align-items: normal;
            justify-content: space-between;
        `,
    },
    dropdownList: {
        css: css`
            border-radius: 0 0 7px 7px;
            box-shadow: 1px 2px 14px 4px rgba(57, 57, 58, 0.25);
            background: ${ADIColors.white};
            position: absolute;
            width: 100%;
            top: 90%;
            z-index: 9;
        `,
    },
    dropdownValues: {
        css: css`
            min-height: 40px;
            border-bottom: 1px solid ${ADIColors.gray3};
            font-weight: 600;
            padding: 13px 12px;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
                border-radius: 0 0 7px 7px;
            }

            &.active,
            &:hover {
                background-color: ${ADIColors.blue1};
                color: ${ADIColors.white};
            }
        `,
    },
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            css: css`
                padding: 6px;
                transform: rotate(90deg);
                height: 45px;
                width: 45px;
                svg {
                    height: 35px;
                    width: 35px;
                    color: ${getColor("common.background")};
                    top: -5px;
                    position: relative;
                }
            `,
        },
        border: "rounded",
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            inputSelect: css`
                border-radius: 6px;
                font-size: 14px;
                width: 100%;
                float: right;
                height: 40px;
                padding: 11px 0 11px 16px;
                font-weight: 600;
                :focus-within {
                    padding: 0px 40px 0px 10px;
                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                    padding: 11px 0 11px 16px;
                                    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                                    border: 1px solid #bbb;
                                    background-color: #fff;
                                `,
                        ],
                        "max",
                    );
                }}
                }
            `,
            formInputWrapper: css`
                display: flex;
                > button {
                    width: 45px !important;
                    height: 45px !important;
                    background: ${ADIColors.blue5};
                    border-radius: 0 4px 4px 0;
                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                    width: 36px !important;
                                    height: 40px !important;
                                    border-radius: 0 6px 6px 0;
                                `,
                        ],
                        "max",
                    );
                }}
                    > ${IconWrapper} {
                        top: 0px;
                        right: 5px;
                        width: 35px;
                        height: 38px;
                        background: transparent !important;
                    }
                }
            `,
        },
    },

    Accordion: {
        css: css`
            margin-bottom: 12px;
            padding: 15px 15px 15px 15px;
            width: 100%;

            > ${AccordionSectionHeader} {
                > Button {
                    background: ${getColor("common.background")};
                    border-top-right-radius: 9px;
                    border-top-left-radius: 9px;
                    > span:last-child {
                        color: #006ae3;
                    }
                }
            }
            > ${AccordionSectionPanel} {
                background: ${getColor("common.background")};
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css` padding: 0px 0px 24px 0px;`,
                    ],
                    "max",
                );
            }}
            }
        `,
    },

    trackOrderTextBox: {
        css: css`
        background-color: green;
        &:focus{
            padding: 9px 15px:
            background-color: yellow;
        }
            > label {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                            margin-bottom: 6px;
                            line-height: 22px;
                            font-weight: 800;
                        `,
                    null,
                    null,
                ])}
            }
        `,
    },
    errorMessage: {
        css: css`
            font-weight: 600;
            text-transform: capitalize;
            font-size: 14px;
        `,
    },

};

const trackOrderDrawer: any = {
    position: "right",
    size: 350,

    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "common.background",
        size: 36,
        css: css`
            padding: 0px;
            border-radius: 0;
            background: transparent;
            border: none;
        `,
        hoverStyle: {
            background: "transparent",
            borderColor: "transparent",
        },
        activeStyle: {
            background: "transparent",
            borderColor: "transparent",
        },
    },
    cssOverrides: {
        scrim: css`
            top: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, css` top: 0px; `,]);
            }}
        `,
        drawerTitle: css`
            background: ${getColor("common.background")};
            position: absolute;
            align-self: flex-end;
            justify-content: center;
            margin: 0px;
            padding: 0px;
            width: 24px;
            height: 24px;
            min-height: 24px;
            top: 20px;
            right: 20px;
            z-index: 999;
            > ${ButtonWrapper} {
                min-height: 24px;
                margin: 0;
            }
        `,
        drawerContent: css`
        height: 100%;
        height: calc(100% - 37px);
            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("common.border")};
                border-radius: 7px;
            }
        `,
        drawerBody: css`
            overflow: hidden auto;
            max-height: 100vh;
            top: 0px;
            width: 375px;
            height: 100%;
            border-radius: 0;
            padding-top: 56px;
            padding-bottom: 60px;
            cursor: default;
            margin: 0px;
            margin-top: -0.1px;
            background: ${getColor("common.background")};
            transform-origin: 100% 50%;
            animation: menuanimation 1s;
            box-shadow: inset -2px 5px 4px -4px rgba(0, 0, 0, 0.28);
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            max-height: 100%;
                            top: 0px;
                            box-shadow: none;
                            width: 100%;
                        `,
                        css`
                            top: 0px;
                        `,
                    ],
                    "max",
                );
            }}
            @keyframes menuanimation {
                0% {
                    right: -374px;
                }
                100% {
                    right: 0px;
                }
            }
        `,
    },

    headlineTypographyProps: {
        color: "text.main",
    },
};
type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = trackOrderStyles;
const StyledForm = getStyledWrapper("form");

const ADITrackOrder: FC<Props> = ({
    session,
    settingsCollection,
    getOrdersParameter,
    loadOrdersList,
    ordersDataView,
    toggleLoginDrawer,
}) => {
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const orders = ordersDataView?.orders;
    const [orderStatus, setOrderStatus] = useState("Select");
    //const trackOrderDrawerState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.trackOrderDrawerStore);
    const [trackOrderDrawerState, setTrackOrderDrawerState] = useState({
        trackOrderDrawer: false,
    });
    const { trackOrderLink } = styles;
    const [openOrderStatus, setOpenOrderStatus] = React.useState(false);
    const orderStatusRef = React.useRef(null);
    // const adiOrderSettingSettings = settingsCollection.adiOrderSettingSettings;
    useOutsideAlerter(orderStatusRef, setOpenOrderStatus);

    const closeModal = () => {
        setOrderErrorMessage(false);
        setTrackOrderErrorMessage(false);
        setTrackOrderDrawerState({
            trackOrderDrawer: false,
        });
    };
    const openModal = () => {
        // toggleLoginDrawer({ loginDrawer: false });
        // setTrackOrderDrawerState({
        //     trackOrderDrawer: true,
        // });
        History.push('/myaccount/Order')
    };

    const orderStatusChangeHandler = (value: string) => {
        if (!value) {
            return;
        }
        // const propsStatus = { status: value };
        setOrderStatus(value);
        setOpenOrderStatus(false);
    };

    const [orderNumberNo, setOrderNumberNo] = useState("");
    const [trackOrderNumber, setTrackOrderNumber] = useState("");

    const submitHandler = (event: any) => {
        event.preventDefault();
    };

    const [orderErrorMessage, setOrderErrorMessage] = useState(false);
    const [trackOrderErrorMessage, setTrackOrderErrorMessage] = useState(false);

    useEffect(() => {
        //setTrackOrderErrorMessage(true);
        //toggleTrackOrderDrawer({ trackOrderDrawer: false });
    }, [orderErrorMessage, trackOrderErrorMessage]);

    const orderInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValues = spaceValidation(event.target.value);
        setOrderNumberNo(inputValues);
        if (!event.target.value) {
            setOrderErrorMessage(true);
        }
        else {
            setOrderErrorMessage(false);
        }
    };
    const trackOrderInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValues = spaceValidation(event.target.value);
        setTrackOrderNumber(inputValues);
        if (!event.target.value) {
            setTrackOrderErrorMessage(true);
        }
        else {
            setTrackOrderErrorMessage(false);
        }
    };

    const handleEnterForSearch = (event: any) => {
        if (event.key === "Enter") {
            handleButtonClick(orderNumberNo);
        }
    };

    const handleEnterForSearchTrckOrder = (event: any) => {
        if (event.key === "Enter") {
            handleButtonClickTrackOrder(trackOrderNumber);
        }
    };
    const History = useHistory();
    // Auth
    const handleButtonClick = (orderNumber: string) => {
        if (getOrdersParameter !== null && getOrdersParameter !== undefined) {
            loadOrdersList({
                ...getOrdersParameter,
                filter: {
                    sort: getOrdersParameter.sort,
                    customerSequence: getOrdersParameter.customerSequence,
                    statusDesc: "All",
                    poNumber: getOrdersParameter.poNumber,
                    //order: "ZK2WFM",
                    ...(getOrdersParameter.properties ? { properties: getOrdersParameter.properties } : { properties: '' }),
                    isSearchActive: getOrdersParameter.isSearchActive
                }
            });
        }

        const getCurrentOrder = orders?.find((item: any) => {
            return orderNumber ? item.webOrderNumber === orderNumber : false;
        });
        const payload: any = {
            OrderNumber: orderNumber
        }
        History.push(`/myaccount/Order`);
        if (getCurrentOrder) {
            setOrderErrorMessage(false);
            closeModal();
            History.push(`/MyAccount/TrackOrder/?orderNumber=${orderNumber}`);

        } else {
            // setOrderErrorMessage(true);
        }
    };

    // Un-Auth
    const handleButtonClickTrackOrder = (orderNumber: any) => {
        const getCurrentOrder = orders?.find((item: any) => {
            return orderNumber ? item.webOrderNumber === orderNumber : false;
        });
        const payload: any = {
            TrackingNumber: orderNumber,
            carrier: orderStatus
        }
        // TrackOrdersList(payload);
        setTrackOrderNumber('');
        setOrderStatus('')
        if (getCurrentOrder) {
            setOrderErrorMessage(false);
            closeModal();
        } else {
            setOrderErrorMessage(true);
        }
    };

    const isButtonDisabled = isAuthenticated
        ? !orderNumberNo.trim() && !trackOrderNumber.trim()
        : (!trackOrderNumber.trim() || orderStatus === "Select");

    const handleClick = isAuthenticated
        ? () => handleButtonClick(orderNumberNo)
        : () => handleButtonClickTrackOrder(trackOrderNumber);

    return (
        <>
            {
                isAuthenticated && (

                    <Link
                        {...trackOrderLink}
                        onClick={() => openModal()}
                        data-test-selector="trackOrderLink"
                    >
                        <Typography>
                            {translate("My Orders")}
                        </Typography>
                    </Link>
                )
            }
            <Drawer
                isOpen={trackOrderDrawerState.trackOrderDrawer}
                {...trackOrderDrawer}
                handleClose={() => closeModal()}
                data-test-selector="trackOrderDrawer"
            >
                <StyledForm onSubmit={submitHandler}>
                    {!isAuthenticated && (
                        <StyledWrapper>
                            <StyledWrapper {...styles.modalTitle}>
                                {translate("My Orders")}
                            </StyledWrapper>
                            <StyledWrapper {...styles.modalContent}>
                                {translate("Enter the tracking number and carrier information that was emailed to you to track your new products.")}
                            </StyledWrapper>
                            <GridContainer {...styles.trackOrderContainer} data-test-selector="track_filter">
                                <GridItem {...styles.trackOrderGrid}>
                                    <Typography as="label" {...styles.formRowLabel}>{translate("Tracking Number *")}</Typography>
                                    <StyledWrapper {...styles.dropdownContainer}>
                                        {trackOrderErrorMessage && (
                                            <Typography {...styles.errorMessage} style={{ color: ADIColors.danger }}>
                                                {translate("Tracking Number not found.")}
                                            </Typography>
                                        )}

                                        <TextField
                                            {...styles.trackOrderTextBox}
                                            id="trackOrderNumber"
                                            onChange={trackOrderInputChangeHandler}
                                            onKeyPress={event => handleEnterForSearchTrckOrder(event)}
                                            value={trackOrderNumber}
                                            error={!!trackOrderErrorMessage}
                                            autoComplete="trackingOrderNumber"
                                            data-test-selector="track_orderNumber"
                                            placeholder="Enter value here..."
                                            maxLength={12}
                                            style={{
                                                borderColor: trackOrderErrorMessage ? ADIColors.danger : ADIColors.gray3,
                                                borderWidth: 1,
                                            }}
                                        />
                                    </StyledWrapper>
                                </GridItem>

                                <GridItem {...styles.gridItem} data-test-selector="ordersStatusGridItem">
                                    <StyledWrapper as="label" {...styles.dropdownLabel}>
                                        {translate("Carrier *")}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.dropdownContainer} ref={orderStatusRef}>
                                        <StyledWrapper
                                            {...styles.dropdownValue}
                                            onClick={() => setOpenOrderStatus(!openOrderStatus)}
                                        >
                                            {orderStatus}
                                            <Typography {...styles.icon}>
                                                {/* <ChevronDown /> */}
                                                <DropDown />
                                            </Typography>
                                        </StyledWrapper>
                                        {openOrderStatus ? (
                                            <StyledWrapper {...styles.dropdownList} as={"ul"}>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Select")}
                                                    className={orderStatus === "Select" ? "active" : "normal"}
                                                >
                                                    {translate("Select")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("All")}
                                                    className={orderStatus === "All" ? "active" : "normal"}
                                                >
                                                    {translate("All")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("R&L Carriers")}
                                                    className={orderStatus === "R&L Carriers" ? "active" : "normal"}
                                                >
                                                    {translate("R&L Carriers")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("FedEx Freight")}
                                                    className={orderStatus === "FedEx Freight" ? "active" : "normal"}
                                                >
                                                    {translate("FedEx Freight")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("SAIA")}
                                                    className={orderStatus === "SAIA" ? "active" : "normal"}
                                                >
                                                    {translate("SAIA")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Duie Pyle")}
                                                    className={orderStatus === "Duie Pyle" ? "active" : "normal"}
                                                >
                                                    {translate("Duie Pyle")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Southeastern Freight Lines")}
                                                    className={orderStatus === "Southeastern Freight Lines" ? "active" : "normal"}
                                                >
                                                    {translate("Southeastern Freight Lines")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("UPS")}
                                                    className={orderStatus === "UPS" ? "active" : "normal"}
                                                >
                                                    {translate("UPS")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Purolator")}
                                                    className={orderStatus === "Purolator" ? "active" : "normal"}
                                                >
                                                    {translate("Purolator")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Day & Ross")}
                                                    className={orderStatus === "Day & Ross" ? "active" : "normal"}
                                                >
                                                    {translate("Day & Ross")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Oak Harbor Freight")}
                                                    className={orderStatus === "Oak Harbor Freight" ? "active" : "normal"}
                                                >
                                                    {translate("Oak Harbor Freight")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("Estes Express")}
                                                    className={orderStatus === "Estes Express" ? "active" : "normal"}
                                                >
                                                    {translate("Estes Express")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("AAA Cooper")}
                                                    className={orderStatus === "AAA Cooper" ? "active" : "normal"}
                                                >
                                                    {translate("AAA Cooper")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("TForce Freight")}
                                                    className={orderStatus === "TForce Freight" ? "active" : "normal"}
                                                >
                                                    {translate("TForce Freight")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("XPO Logistics")}
                                                    className={orderStatus === "XPO Logistics" ? "active" : "normal"}
                                                >
                                                    {translate("XPO Logistics")}
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => orderStatusChangeHandler("ABF Freight")}
                                                    className={orderStatus === "ABF Freight" ? "active" : "normal"}
                                                >
                                                    {translate("ABF Freight")}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ) : null}
                                    </StyledWrapper>
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    )}

                    {isAuthenticated && (
                        <StyledWrapper>
                            <StyledWrapper {...styles.modalTitle}>
                                {translate("My Orders")}
                            </StyledWrapper>
                            <StyledWrapper {...styles.modalContent}>
                                {translate("Enter your order number to track your new products.")}
                            </StyledWrapper>
                            <GridContainer {...styles.trackOrderContainer}>
                                <GridItem {...styles.trackOrderGrid}>
                                    <Typography as="label" {...styles.formRowLabel}>{translate("Order Number *")}</Typography>
                                    <StyledWrapper {...styles.dropdownContainer}>
                                        {orderErrorMessage && (
                                            <Typography {...styles.errorMessage} style={{ color: ADIColors.danger }}>
                                                {translate("Order not found.")}
                                            </Typography>
                                        )}

                                        <TextField
                                            {...styles.trackOrderTextBox}
                                            id="orderNumber"
                                            onChange={orderInputChangeHandler}
                                            onKeyPress={event => handleEnterForSearch(event)}
                                            value={orderNumberNo}
                                            error={!!orderErrorMessage}
                                            autoComplete="orderNumber"
                                            data-test-selector="track_orderNumber"
                                            placeholder="Enter value here..."
                                            maxLength={12}
                                            style={{
                                                borderColor: orderErrorMessage ? ADIColors.danger : ADIColors.gray3,
                                                borderWidth: 1,
                                            }}
                                        />
                                    </StyledWrapper>
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    )}

                    <GridContainer {...styles.trackOrderButtonContainer}>
                        <GridItem {...styles.trackOrderButtonGridItem}>
                            <Button variant="secondary" {...styles.secondaryBtutton} onClick={closeModal}>
                                {translate("Cancel")}
                            </Button>
                            <Button
                                {...styles.primaryButton}
                                onClick={handleClick}
                                disabled={isButtonDisabled}
                            >
                                {translate("Check Order Status")}
                            </Button>
                        </GridItem>
                    </GridContainer>
                </StyledForm>
            </Drawer>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADITrackOrder);

